function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  transform: "translate(.672 .672)"
}, React.createElement("circle", {
  cx: 15.363,
  cy: 15.45,
  r: 15.218,
  fill: "#EA4235"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M15.363 25.964c-3.601 0-6.767-2.905-6.767-6.564 0-2.236 1.046-4.037 3.02-5.082-1.132-1.104-1.8-2.207-1.8-3.834 0-3.136 2.41-5.576 5.547-5.576 3.137 0 5.576 2.44 5.576 5.576 0 1.627-.697 2.73-1.83 3.834 1.976 1.045 3.021 2.846 3.021 5.082-.029 3.66-3.166 6.564-6.767 6.564zm0-9.671a3.111 3.111 0 0 0-3.107 3.107 3.111 3.111 0 0 0 3.107 3.108 3.111 3.111 0 0 0 3.108-3.108 3.111 3.111 0 0 0-3.108-3.107zm0-7.929c-1.19 0-2.12 1.017-2.12 2.178 0 1.162.959 2.15 2.12 2.15 1.162 0 2.15-.988 2.15-2.15 0-1.19-.96-2.178-2.15-2.178z"
}));

var Svg8BaseEmblem = function Svg8BaseEmblem(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/8base-emblem.2fdc67ff.svg";
export { Svg8BaseEmblem as ReactComponent };